import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "view-result-card-component" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "background-linear" }, null, -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "cares-info open-sans-font" }
const _hoisted_5 = { class: "iframe-container mb-24" }
const _hoisted_6 = { class: "iframe-wrapper" }
const _hoisted_7 = { class: "iframe-position" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "clinicarx-buttons" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "info open-sans-font" }, " Precisa de um teste confirmatório? ", -1)
const _hoisted_11 = { class: "button-custom" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "open-sans-font" }, "Encontrar uma farmácia", -1)
const _hoisted_14 = { class: "footer" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "legal-info open-sans-font" }, " O autoteste não configura um exame laboratorial e esse cartão de resultado não tem valor legal e nem de laudo oficial. Para os casos de laudo para viagens, atestados de trabalho, eventos ou outro fim comprobatório, deve-se procurar uma farmácia para realizar o teste com um profissional da saúde. ", -1)
const _hoisted_16 = { class: "powered-container" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Powered By", -1)
const _hoisted_18 = ["src"]
const _hoisted_19 = { id: "printable-container-email" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "logo-result" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logoShareResult-right" }),
  /*#__PURE__*/_createElementVNode("div", { class: "logoShareResult-left" })
], -1)
const _hoisted_21 = { id: "result-card-component" }
const _hoisted_22 = { class: "info-name" }
const _hoisted_23 = { class: "info-line" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Data de nascimento:")
], -1)
const _hoisted_25 = { class: "info-value" }
const _hoisted_26 = {
  key: 0,
  class: "info-line"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "CPF:")
], -1)
const _hoisted_28 = { class: "info-value" }
const _hoisted_29 = {
  key: 1,
  class: "info-line"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "info-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Localidade:")
], -1)
const _hoisted_31 = { class: "info-value" }
const _hoisted_32 = { class: "result-test-header" }
const _hoisted_33 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_34 = { class: "title open-sans-font" }
const _hoisted_35 = { class: "result-test-image d-flex justify-content-center" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "info-value-test" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h3", null, "Tipo de Teste:", -1)
const _hoisted_39 = { class: "info-value test-name-result" }
const _hoisted_40 = { class: "info-value-test" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h3", null, "Data de Registro:", -1)
const _hoisted_42 = { class: "info-value test-date" }
const _hoisted_43 = { class: "result-card-footer" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "dashed-line" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "logomark open-sans-font" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_result_card_header = _resolveComponent("view-result-card-header")!
  const _component_info_slider_component = _resolveComponent("info-slider-component")!
  const _component_online_appointment = _resolveComponent("online-appointment")!
  const _component_result_card_modal = _resolveComponent("result-card-modal")!
  const _component_warning_test_modal = _resolveComponent("warning-test-modal")!
  const _component_result_card = _resolveComponent("result-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_view_result_card_header, {
          "user-name": _ctx.patient.name
        }, null, 8, ["user-name"]),
        _createVNode(_component_info_slider_component, {
          "result-infos": _ctx.resultInfos,
          onOpenResultCard: _ctx.openResultCard
        }, null, 8, ["result-infos", "onOpenResultCard"]),
        _createVNode(_component_online_appointment, { link: "https://clinicarx.conectamedico.com.br/" }),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.resultInfos.titleVideoResult), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("iframe", {
                src: _ctx.resultInfos.urlVideo,
                width: "100%",
                height: "200",
                mozallowfullscreen: "",
                webkitallowfullscreen: "",
                frameborder: "0",
                allow: "autoplay; fullscreen",
                allowfullscreen: ""
              }, "\n            ", 8, _hoisted_8)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "button-container",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.openLink('https://webapp.clinicarx.com.br/onde-encontrar', 'sched')
          ))
          }, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("img", { src: _ctx.pharmacyIconPath }, null, 8, _hoisted_12),
              _hoisted_13
            ])
          ])
        ]),
        _createVNode(_component_result_card_modal, {
          id: "card-result-modal",
          ref: "result-modal"
        }, null, 512),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("img", { src: _ctx.logoClinicarxPath }, null, 8, _hoisted_18)
          ])
        ])
      ])
    ]),
    _createVNode(_component_warning_test_modal, { ref: "warning-test-modal" }, null, 512),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createVNode(_component_result_card, { class: "custom-result-card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.patient.name), 1),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.patient.birthdate), 1)
            ]),
            (!_ctx.patient.isForeigner)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.cpfMask()), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.patient.isForeigner)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.patient.city) + " - " + _toDisplayString(_ctx.patient.state), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.resultInfos.title) + " " + _toDisplayString(_ctx.resultInfos.subtitle), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("img", { src: _ctx.testImage }, null, 8, _hoisted_36)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.testName), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.getCurrentDate()), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("span", null, _toDisplayString(_ctx.agePatient()), 1)
            ]),
            _hoisted_44
          ])
        ]),
        _: 1
      }),
      _hoisted_45
    ])
  ], 64))
}